import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { SatelliteMachineUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";
import { InputSecret } from "../../../common/controls";
import { InputDateTime } from "../../../common/controls";
import { InputReference } from "../../../common/controls";
import { CreateEntityDialog } from "../../../common/controls";
import { UserCreate } from "../../../user/components/create/UserCreate";
import { UserCreateStore } from "../../../user/store";
import { InputBoolean } from "../../../common/controls";
import { InputNumber } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";

export type SatelliteMachineUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  nameError?: string;
  machineCode: string;
  machineCodeSelectedValue?: { displayId: string; id: string } | null;
  onMachineCodeChange?: (value: string) => void;
  machineCodeError?: string;
  satelliteType: string;
  satelliteTypeSelectedValue?: { displayId: string; id: string } | null;
  onSatelliteTypeChange?: (value: string) => void;
  satelliteTypeError?: string;
  region: string;
  regionSelectedValue?: { displayId: string; id: string } | null;
  onRegionChange?: (value: string) => void;
  regionError?: string;
  certificateFingerprint: string;
  certificateFingerprintSelectedValue?: {
    displayId: string;
    id: string;
  } | null;
  onCertificateFingerprintChange?: (value: string) => void;
  certificateFingerprintError?: string;
  certificateExpiresAt: Date | null;
  certificateExpiresAtSelectedValue?: { displayId: string; id: string } | null;
  onCertificateExpiresAtChange?: (value: Date | null) => void;
  certificateExpiresAtError?: string;
  authTokenHash: string;
  authTokenHashSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenHashChange?: (value: string) => void;
  authTokenHashError?: string;
  authTokenLastFour: string;
  authTokenLastFourSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenLastFourChange?: (value: string) => void;
  authTokenLastFourError?: string;
  authTokenCreatedAt: Date | null;
  authTokenCreatedAtSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenCreatedAtChange?: (value: Date | null) => void;
  authTokenCreatedAtError?: string;
  authTokenRotatedAt: Date | null;
  authTokenRotatedAtSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenRotatedAtChange?: (value: Date | null) => void;
  authTokenRotatedAtError?: string;
  status: string;
  statusSelectedValue?: { displayId: string; id: string } | null;
  onStatusChange?: (value: string) => void;
  statusError?: string;
  authorizedAt: Date | null;
  authorizedAtSelectedValue?: { displayId: string; id: string } | null;
  onAuthorizedAtChange?: (value: Date | null) => void;
  authorizedAtError?: string;
  authorizedBySelectedValue?: { displayId: string; id: string } | null;
  onAuthorizedByChange?: (value: string) => void;
  onAuthorizedBySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  authorizedByOptions?: { displayId: string; id: string }[];
  authorizedByError?: string;
  suspendedAt: Date | null;
  suspendedAtSelectedValue?: { displayId: string; id: string } | null;
  onSuspendedAtChange?: (value: Date | null) => void;
  suspendedAtError?: string;
  suspendedBySelectedValue?: { displayId: string; id: string } | null;
  onSuspendedByChange?: (value: string) => void;
  onSuspendedBySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  suspendedByOptions?: { displayId: string; id: string }[];
  suspendedByError?: string;
  suspensionReason: string;
  suspensionReasonSelectedValue?: { displayId: string; id: string } | null;
  onSuspensionReasonChange?: (value: string) => void;
  suspensionReasonError?: string;
  enabled: boolean;
  enabledSelectedValue?: { displayId: string; id: string } | null;
  onEnabledChange?: (value: boolean) => void;
  enabledError?: string;
  allowedTenantIds: string;
  allowedTenantIdsSelectedValue?: { displayId: string; id: string } | null;
  onAllowedTenantIdsChange?: (value: string) => void;
  allowedTenantIdsError?: string;
  proxyEnabled: boolean;
  proxyEnabledSelectedValue?: { displayId: string; id: string } | null;
  onProxyEnabledChange?: (value: boolean) => void;
  proxyEnabledError?: string;
  proxyPort: number | undefined;
  proxyPortSelectedValue?: { displayId: string; id: string } | null;
  onProxyPortChange?: (value: number | undefined) => void;
  proxyPortError?: string;
  proxyProtocols: string;
  proxyProtocolsSelectedValue?: { displayId: string; id: string } | null;
  onProxyProtocolsChange?: (value: string) => void;
  proxyProtocolsError?: string;
  botEnabled: boolean;
  botEnabledSelectedValue?: { displayId: string; id: string } | null;
  onBotEnabledChange?: (value: boolean) => void;
  botEnabledError?: string;
  botMaxConcurrent: number | undefined;
  botMaxConcurrentSelectedValue?: { displayId: string; id: string } | null;
  onBotMaxConcurrentChange?: (value: number | undefined) => void;
  botMaxConcurrentError?: string;
  workerEnabled: boolean;
  workerEnabledSelectedValue?: { displayId: string; id: string } | null;
  onWorkerEnabledChange?: (value: boolean) => void;
  workerEnabledError?: string;
  publicIp: string;
  publicIpSelectedValue?: { displayId: string; id: string } | null;
  onPublicIpChange?: (value: string) => void;
  publicIpError?: string;
  location: string;
  locationSelectedValue?: { displayId: string; id: string } | null;
  onLocationChange?: (value: string) => void;
  locationError?: string;
  countryCode: string;
  countryCodeSelectedValue?: { displayId: string; id: string } | null;
  onCountryCodeChange?: (value: string) => void;
  countryCodeError?: string;
  lastHeartbeatAt: Date | null;
  lastHeartbeatAtSelectedValue?: { displayId: string; id: string } | null;
  onLastHeartbeatAtChange?: (value: Date | null) => void;
  lastHeartbeatAtError?: string;
  lastHeartbeatMetrics: string;
  lastHeartbeatMetricsSelectedValue?: { displayId: string; id: string } | null;
  onLastHeartbeatMetricsChange?: (value: string) => void;
  lastHeartbeatMetricsError?: string;
  connectedAt: Date | null;
  connectedAtSelectedValue?: { displayId: string; id: string } | null;
  onConnectedAtChange?: (value: Date | null) => void;
  connectedAtError?: string;
  disconnectedAt: Date | null;
  disconnectedAtSelectedValue?: { displayId: string; id: string } | null;
  onDisconnectedAtChange?: (value: Date | null) => void;
  disconnectedAtError?: string;
  tunnelConnectedAt: Date | null;
  tunnelConnectedAtSelectedValue?: { displayId: string; id: string } | null;
  onTunnelConnectedAtChange?: (value: Date | null) => void;
  tunnelConnectedAtError?: string;
  satelliteMachineUpdateStore: SatelliteMachineUpdateStore;
};

export const SatelliteMachineUpdateForm: React.FC<SatelliteMachineUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      machineCode = "",
      machineCodeError,
      onMachineCodeChange = () => {},
      satelliteType = "",
      satelliteTypeError,
      onSatelliteTypeChange = () => {},
      region = "",
      regionError,
      onRegionChange = () => {},
      certificateFingerprint = "",
      certificateFingerprintError,
      onCertificateFingerprintChange = () => {},
      certificateExpiresAt = null,
      certificateExpiresAtError,
      onCertificateExpiresAtChange = () => {},
      authTokenHash = "",
      authTokenHashError,
      onAuthTokenHashChange = () => {},
      authTokenLastFour = "",
      authTokenLastFourError,
      onAuthTokenLastFourChange = () => {},
      authTokenCreatedAt = null,
      authTokenCreatedAtError,
      onAuthTokenCreatedAtChange = () => {},
      authTokenRotatedAt = null,
      authTokenRotatedAtError,
      onAuthTokenRotatedAtChange = () => {},
      status = "",
      statusError,
      onStatusChange = () => {},
      authorizedAt = null,
      authorizedAtError,
      onAuthorizedAtChange = () => {},
      onAuthorizedBySelected = () => {},
      authorizedByOptions = [],
      authorizedBySelectedValue = null,
      authorizedByError,
      onAuthorizedByChange = () => {},
      suspendedAt = null,
      suspendedAtError,
      onSuspendedAtChange = () => {},
      onSuspendedBySelected = () => {},
      suspendedByOptions = [],
      suspendedBySelectedValue = null,
      suspendedByError,
      onSuspendedByChange = () => {},
      suspensionReason = "",
      suspensionReasonError,
      onSuspensionReasonChange = () => {},
      enabled = false,
      enabledError,
      onEnabledChange = () => {},
      allowedTenantIds = "",
      allowedTenantIdsError,
      onAllowedTenantIdsChange = () => {},
      proxyEnabled = false,
      proxyEnabledError,
      onProxyEnabledChange = () => {},
      proxyPort = undefined,
      proxyPortError,
      onProxyPortChange = () => {},
      proxyProtocols = "",
      proxyProtocolsError,
      onProxyProtocolsChange = () => {},
      botEnabled = false,
      botEnabledError,
      onBotEnabledChange = () => {},
      botMaxConcurrent = undefined,
      botMaxConcurrentError,
      onBotMaxConcurrentChange = () => {},
      workerEnabled = false,
      workerEnabledError,
      onWorkerEnabledChange = () => {},
      publicIp = "",
      publicIpError,
      onPublicIpChange = () => {},
      location = "",
      locationError,
      onLocationChange = () => {},
      countryCode = "",
      countryCodeError,
      onCountryCodeChange = () => {},
      lastHeartbeatAt = null,
      lastHeartbeatAtError,
      onLastHeartbeatAtChange = () => {},
      lastHeartbeatMetrics = "{}",
      lastHeartbeatMetricsError,
      onLastHeartbeatMetricsChange = () => {},
      connectedAt = null,
      connectedAtError,
      onConnectedAtChange = () => {},
      disconnectedAt = null,
      disconnectedAtError,
      onDisconnectedAtChange = () => {},
      tunnelConnectedAt = null,
      tunnelConnectedAtError,
      onTunnelConnectedAtChange = () => {},
      satelliteMachineUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="SatelliteMachine"
              mode="update"
              values={{}}
              options={{
                authorizedBy: authorizedByOptions,
                suspendedBy: suspendedByOptions,
              }}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                  case "machineCode":
                    onMachineCodeChange?.(valor);
                    break;
                  case "satelliteType":
                    onSatelliteTypeChange?.(valor);
                    break;
                  case "region":
                    onRegionChange?.(valor);
                    break;
                  case "certificateFingerprint":
                    onCertificateFingerprintChange?.(valor);
                    break;
                  case "certificateExpiresAt":
                    onCertificateExpiresAtChange?.(valor);
                    break;
                  case "authTokenHash":
                    onAuthTokenHashChange?.(valor);
                    break;
                  case "authTokenLastFour":
                    onAuthTokenLastFourChange?.(valor);
                    break;
                  case "authTokenCreatedAt":
                    onAuthTokenCreatedAtChange?.(valor);
                    break;
                  case "authTokenRotatedAt":
                    onAuthTokenRotatedAtChange?.(valor);
                    break;
                  case "status":
                    onStatusChange?.(valor);
                    break;
                  case "authorizedAt":
                    onAuthorizedAtChange?.(valor);
                    break;
                  case "authorizedBy":
                    onAuthorizedBySelected?.(valor);
                    break;
                  case "suspendedAt":
                    onSuspendedAtChange?.(valor);
                    break;
                  case "suspendedBy":
                    onSuspendedBySelected?.(valor);
                    break;
                  case "suspensionReason":
                    onSuspensionReasonChange?.(valor);
                    break;
                  case "enabled":
                    onEnabledChange?.(valor);
                    break;
                  case "allowedTenantIds":
                    onAllowedTenantIdsChange?.(valor);
                    break;
                  case "proxyEnabled":
                    onProxyEnabledChange?.(valor);
                    break;
                  case "proxyPort":
                    onProxyPortChange?.(valor);
                    break;
                  case "proxyProtocols":
                    onProxyProtocolsChange?.(valor);
                    break;
                  case "botEnabled":
                    onBotEnabledChange?.(valor);
                    break;
                  case "botMaxConcurrent":
                    onBotMaxConcurrentChange?.(valor);
                    break;
                  case "workerEnabled":
                    onWorkerEnabledChange?.(valor);
                    break;
                  case "publicIp":
                    onPublicIpChange?.(valor);
                    break;
                  case "location":
                    onLocationChange?.(valor);
                    break;
                  case "countryCode":
                    onCountryCodeChange?.(valor);
                    break;
                  case "lastHeartbeatAt":
                    onLastHeartbeatAtChange?.(valor);
                    break;
                  case "lastHeartbeatMetrics":
                    onLastHeartbeatMetricsChange?.(valor);
                    break;
                  case "connectedAt":
                    onConnectedAtChange?.(valor);
                    break;
                  case "disconnectedAt":
                    onDisconnectedAtChange?.(valor);
                    break;
                  case "tunnelConnectedAt":
                    onTunnelConnectedAtChange?.(valor);
                    break;
                }
              }}
            />

            <GroupContainer
              id="identity"
              errorText={satelliteMachineUpdateStore.getCardErrors("identity")}
              title={langStore.groupSatelliteMachineIdentityLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState("identity")}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("identity")
              }
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(satelliteMachineUpdateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    satelliteMachineUpdateStore.warnings["name"]?.message
                  }
                  label={langStore.SatelliteMachineNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.SatelliteMachineNameDescription}
                />
                <InputString
                  value={machineCode}
                  error={Boolean(machineCodeError)}
                  warning={
                    !machineCodeError &&
                    Boolean(satelliteMachineUpdateStore.warnings["machineCode"])
                  }
                  helperText={
                    machineCodeError ||
                    satelliteMachineUpdateStore.warnings["machineCode"]?.message
                  }
                  label={langStore.SatelliteMachineMachineCodeLabel}
                  onChange={(value: string) => onMachineCodeChange(value)}
                  description={langStore.SatelliteMachineMachineCodeDescription}
                />
                <InputString
                  value={satelliteType}
                  error={Boolean(satelliteTypeError)}
                  warning={
                    !satelliteTypeError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["satelliteType"]
                    )
                  }
                  helperText={
                    satelliteTypeError ||
                    satelliteMachineUpdateStore.warnings["satelliteType"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineSatelliteTypeLabel}
                  onChange={(value: string) => onSatelliteTypeChange(value)}
                  description={
                    langStore.SatelliteMachineSatelliteTypeDescription
                  }
                />
                <InputString
                  value={region}
                  error={Boolean(regionError)}
                  warning={
                    !regionError &&
                    Boolean(satelliteMachineUpdateStore.warnings["region"])
                  }
                  helperText={
                    regionError ||
                    satelliteMachineUpdateStore.warnings["region"]?.message
                  }
                  label={langStore.SatelliteMachineRegionLabel}
                  onChange={(value: string) => onRegionChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineRegionDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="certificate"
              errorText={satelliteMachineUpdateStore.getCardErrors(
                "certificate"
              )}
              title={langStore.groupSatelliteMachineCertificateLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState("certificate")}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("certificate")
              }
            >
              <FormControl fullWidth>
                <InputSecret
                  value={certificateFingerprint}
                  error={Boolean(certificateFingerprintError)}
                  helperText={
                    certificateFingerprintError ||
                    satelliteMachineUpdateStore.warnings[
                      "certificateFingerprint"
                    ]?.message
                  }
                  label={langStore.SatelliteMachineCertificateFingerprintLabel}
                  onChange={(value: string) =>
                    onCertificateFingerprintChange(value)
                  }
                  description={
                    langStore.SatelliteMachineCertificateFingerprintDescription
                  }
                />
                <InputDateTime
                  value={certificateExpiresAt}
                  error={Boolean(certificateExpiresAtError)}
                  warning={
                    !certificateExpiresAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings[
                        "certificateExpiresAt"
                      ]
                    )
                  }
                  helperText={
                    certificateExpiresAtError ||
                    satelliteMachineUpdateStore.warnings["certificateExpiresAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineCertificateExpiresAtLabel}
                  description={
                    langStore.SatelliteMachineCertificateExpiresAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onCertificateExpiresAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="authentication"
              errorText={satelliteMachineUpdateStore.getCardErrors(
                "authentication"
              )}
              title={langStore.groupSatelliteMachineAuthenticationLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState(
                "authentication"
              )}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("authentication")
              }
            >
              <FormControl fullWidth>
                <InputSecret
                  value={authTokenHash}
                  error={Boolean(authTokenHashError)}
                  helperText={
                    authTokenHashError ||
                    satelliteMachineUpdateStore.warnings["authTokenHash"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenHashLabel}
                  onChange={(value: string) => onAuthTokenHashChange(value)}
                  description={
                    langStore.SatelliteMachineAuthTokenHashDescription
                  }
                />
                <InputString
                  value={authTokenLastFour}
                  error={Boolean(authTokenLastFourError)}
                  warning={
                    !authTokenLastFourError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["authTokenLastFour"]
                    )
                  }
                  helperText={
                    authTokenLastFourError ||
                    satelliteMachineUpdateStore.warnings["authTokenLastFour"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenLastFourLabel}
                  onChange={(value: string) => onAuthTokenLastFourChange(value)}
                  description={
                    langStore.SatelliteMachineAuthTokenLastFourDescription
                  }
                />
                <InputDateTime
                  value={authTokenCreatedAt}
                  error={Boolean(authTokenCreatedAtError)}
                  warning={
                    !authTokenCreatedAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["authTokenCreatedAt"]
                    )
                  }
                  helperText={
                    authTokenCreatedAtError ||
                    satelliteMachineUpdateStore.warnings["authTokenCreatedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenCreatedAtLabel}
                  description={
                    langStore.SatelliteMachineAuthTokenCreatedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onAuthTokenCreatedAtChange(value)
                  }
                />
                <InputDateTime
                  value={authTokenRotatedAt}
                  error={Boolean(authTokenRotatedAtError)}
                  warning={
                    !authTokenRotatedAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["authTokenRotatedAt"]
                    )
                  }
                  helperText={
                    authTokenRotatedAtError ||
                    satelliteMachineUpdateStore.warnings["authTokenRotatedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenRotatedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineAuthTokenRotatedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onAuthTokenRotatedAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="authorization"
              errorText={satelliteMachineUpdateStore.getCardErrors(
                "authorization"
              )}
              title={langStore.groupSatelliteMachineAuthorizationLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState(
                "authorization"
              )}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("authorization")
              }
            >
              <FormControl fullWidth>
                <InputString
                  value={status}
                  error={Boolean(statusError)}
                  warning={
                    !statusError &&
                    Boolean(satelliteMachineUpdateStore.warnings["status"])
                  }
                  helperText={
                    statusError ||
                    satelliteMachineUpdateStore.warnings["status"]?.message
                  }
                  label={langStore.SatelliteMachineStatusLabel}
                  onChange={(value: string) => onStatusChange(value)}
                  description={langStore.SatelliteMachineStatusDescription}
                />
                <InputDateTime
                  value={authorizedAt}
                  error={Boolean(authorizedAtError)}
                  warning={
                    !authorizedAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["authorizedAt"]
                    )
                  }
                  helperText={
                    authorizedAtError ||
                    satelliteMachineUpdateStore.warnings["authorizedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthorizedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineAuthorizedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onAuthorizedAtChange(value)
                  }
                />
                <InputReference
                  id="authorizedBy"
                  label={langStore.SatelliteMachineAuthorizedByLabel}
                  error={Boolean(authorizedByError)}
                  helperText={
                    authorizedByError ||
                    satelliteMachineUpdateStore.warnings["authorizedBy"]
                      ?.message
                  }
                  selectedValue={authorizedBySelectedValue}
                  onChange={(value: string) => onAuthorizedByChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onAuthorizedBySelected(value)
                  }
                  options={authorizedByOptions}
                  description={
                    langStore.SatelliteMachineAuthorizedByDescription
                  }
                  nullText={langStore.optionalFieldHint}
                  canCreate={rootStore.authStore.hasPermissions("user_create")}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new UserCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <UserCreate
                          userCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewUser"
                      cancelMethod="cancelNewUser"
                    />
                  )}
                />
                <InputDateTime
                  value={suspendedAt}
                  error={Boolean(suspendedAtError)}
                  warning={
                    !suspendedAtError &&
                    Boolean(satelliteMachineUpdateStore.warnings["suspendedAt"])
                  }
                  helperText={
                    suspendedAtError ||
                    satelliteMachineUpdateStore.warnings["suspendedAt"]?.message
                  }
                  label={langStore.SatelliteMachineSuspendedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineSuspendedAtDescription}
                  onChange={(value: Date | null | null) =>
                    onSuspendedAtChange(value)
                  }
                />
                <InputReference
                  id="suspendedBy"
                  label={langStore.SatelliteMachineSuspendedByLabel}
                  error={Boolean(suspendedByError)}
                  helperText={
                    suspendedByError ||
                    satelliteMachineUpdateStore.warnings["suspendedBy"]?.message
                  }
                  selectedValue={suspendedBySelectedValue}
                  onChange={(value: string) => onSuspendedByChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onSuspendedBySelected(value)
                  }
                  options={suspendedByOptions}
                  description={langStore.SatelliteMachineSuspendedByDescription}
                  nullText={langStore.optionalFieldHint}
                  canCreate={rootStore.authStore.hasPermissions("user_create")}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new UserCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <UserCreate
                          userCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewUser"
                      cancelMethod="cancelNewUser"
                    />
                  )}
                />
                <InputString
                  value={suspensionReason}
                  error={Boolean(suspensionReasonError)}
                  warning={
                    !suspensionReasonError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["suspensionReason"]
                    )
                  }
                  helperText={
                    suspensionReasonError ||
                    satelliteMachineUpdateStore.warnings["suspensionReason"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineSuspensionReasonLabel}
                  onChange={(value: string) => onSuspensionReasonChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineSuspensionReasonDescription
                  }
                />
                <InputBoolean
                  value={enabled}
                  error={Boolean(enabledError)}
                  helperText={
                    enabledError ||
                    satelliteMachineUpdateStore.warnings["enabled"]?.message
                  }
                  label={langStore.SatelliteMachineEnabledLabel}
                  description={langStore.SatelliteMachineEnabledDescription}
                  onChange={(value: boolean) => onEnabledChange(value)}
                />
                <InputString
                  value={allowedTenantIds}
                  error={Boolean(allowedTenantIdsError)}
                  warning={
                    !allowedTenantIdsError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["allowedTenantIds"]
                    )
                  }
                  helperText={
                    allowedTenantIdsError ||
                    satelliteMachineUpdateStore.warnings["allowedTenantIds"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAllowedTenantIdsLabel}
                  onChange={(value: string) => onAllowedTenantIdsChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineAllowedTenantIdsDescription
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="capabilities"
              errorText={satelliteMachineUpdateStore.getCardErrors(
                "capabilities"
              )}
              title={langStore.groupSatelliteMachineCapabilitiesLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState(
                "capabilities"
              )}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("capabilities")
              }
            >
              <FormControl fullWidth>
                <InputBoolean
                  value={proxyEnabled}
                  error={Boolean(proxyEnabledError)}
                  helperText={
                    proxyEnabledError ||
                    satelliteMachineUpdateStore.warnings["proxyEnabled"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineProxyEnabledLabel}
                  description={
                    langStore.SatelliteMachineProxyEnabledDescription
                  }
                  onChange={(value: boolean) => onProxyEnabledChange(value)}
                />
                <InputNumber
                  value={proxyPort}
                  nullable={true}
                  error={Boolean(proxyPortError)}
                  warning={
                    !proxyPortError &&
                    Boolean(satelliteMachineUpdateStore.warnings["proxyPort"])
                  }
                  helperText={
                    proxyPortError ||
                    satelliteMachineUpdateStore.warnings["proxyPort"]?.message
                  }
                  label={langStore.SatelliteMachineProxyPortLabel}
                  decimalScale={0}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineProxyPortDescription}
                  onChange={(value: number | undefined) =>
                    onProxyPortChange(value)
                  }
                />
                <InputString
                  value={proxyProtocols}
                  error={Boolean(proxyProtocolsError)}
                  warning={
                    !proxyProtocolsError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["proxyProtocols"]
                    )
                  }
                  helperText={
                    proxyProtocolsError ||
                    satelliteMachineUpdateStore.warnings["proxyProtocols"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineProxyProtocolsLabel}
                  onChange={(value: string) => onProxyProtocolsChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineProxyProtocolsDescription
                  }
                />
                <InputBoolean
                  value={botEnabled}
                  error={Boolean(botEnabledError)}
                  helperText={
                    botEnabledError ||
                    satelliteMachineUpdateStore.warnings["botEnabled"]?.message
                  }
                  label={langStore.SatelliteMachineBotEnabledLabel}
                  description={langStore.SatelliteMachineBotEnabledDescription}
                  onChange={(value: boolean) => onBotEnabledChange(value)}
                />
                <InputNumber
                  value={botMaxConcurrent}
                  nullable={true}
                  error={Boolean(botMaxConcurrentError)}
                  warning={
                    !botMaxConcurrentError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["botMaxConcurrent"]
                    )
                  }
                  helperText={
                    botMaxConcurrentError ||
                    satelliteMachineUpdateStore.warnings["botMaxConcurrent"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineBotMaxConcurrentLabel}
                  decimalScale={0}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineBotMaxConcurrentDescription
                  }
                  onChange={(value: number | undefined) =>
                    onBotMaxConcurrentChange(value)
                  }
                />
                <InputBoolean
                  value={workerEnabled}
                  error={Boolean(workerEnabledError)}
                  helperText={
                    workerEnabledError ||
                    satelliteMachineUpdateStore.warnings["workerEnabled"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineWorkerEnabledLabel}
                  description={
                    langStore.SatelliteMachineWorkerEnabledDescription
                  }
                  onChange={(value: boolean) => onWorkerEnabledChange(value)}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="network"
              errorText={satelliteMachineUpdateStore.getCardErrors("network")}
              title={langStore.groupSatelliteMachineNetworkLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState("network")}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("network")
              }
            >
              <FormControl fullWidth>
                <InputString
                  value={publicIp}
                  error={Boolean(publicIpError)}
                  warning={
                    !publicIpError &&
                    Boolean(satelliteMachineUpdateStore.warnings["publicIp"])
                  }
                  helperText={
                    publicIpError ||
                    satelliteMachineUpdateStore.warnings["publicIp"]?.message
                  }
                  label={langStore.SatelliteMachinePublicIpLabel}
                  onChange={(value: string) => onPublicIpChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachinePublicIpDescription}
                />
                <InputString
                  value={location}
                  error={Boolean(locationError)}
                  warning={
                    !locationError &&
                    Boolean(satelliteMachineUpdateStore.warnings["location"])
                  }
                  helperText={
                    locationError ||
                    satelliteMachineUpdateStore.warnings["location"]?.message
                  }
                  label={langStore.SatelliteMachineLocationLabel}
                  onChange={(value: string) => onLocationChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineLocationDescription}
                />
                <InputString
                  value={countryCode}
                  error={Boolean(countryCodeError)}
                  warning={
                    !countryCodeError &&
                    Boolean(satelliteMachineUpdateStore.warnings["countryCode"])
                  }
                  helperText={
                    countryCodeError ||
                    satelliteMachineUpdateStore.warnings["countryCode"]?.message
                  }
                  label={langStore.SatelliteMachineCountryCodeLabel}
                  onChange={(value: string) => onCountryCodeChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineCountryCodeDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="monitoring"
              errorText={satelliteMachineUpdateStore.getCardErrors(
                "monitoring"
              )}
              title={langStore.groupSatelliteMachineMonitoringLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState("monitoring")}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("monitoring")
              }
            >
              <FormControl fullWidth>
                <InputDateTime
                  value={lastHeartbeatAt}
                  error={Boolean(lastHeartbeatAtError)}
                  warning={
                    !lastHeartbeatAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["lastHeartbeatAt"]
                    )
                  }
                  helperText={
                    lastHeartbeatAtError ||
                    satelliteMachineUpdateStore.warnings["lastHeartbeatAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineLastHeartbeatAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineLastHeartbeatAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onLastHeartbeatAtChange(value)
                  }
                />
                <InputCodeEditor
                  value={lastHeartbeatMetrics}
                  error={Boolean(lastHeartbeatMetricsError)}
                  helperText={
                    lastHeartbeatMetricsError ||
                    satelliteMachineUpdateStore.warnings["lastHeartbeatMetrics"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineLastHeartbeatMetricsLabel}
                  onChange={(value: string) =>
                    onLastHeartbeatMetricsChange(value)
                  }
                  language="json"
                  description={
                    langStore.SatelliteMachineLastHeartbeatMetricsDescription
                  }
                />
                <InputDateTime
                  value={connectedAt}
                  error={Boolean(connectedAtError)}
                  warning={
                    !connectedAtError &&
                    Boolean(satelliteMachineUpdateStore.warnings["connectedAt"])
                  }
                  helperText={
                    connectedAtError ||
                    satelliteMachineUpdateStore.warnings["connectedAt"]?.message
                  }
                  label={langStore.SatelliteMachineConnectedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineConnectedAtDescription}
                  onChange={(value: Date | null | null) =>
                    onConnectedAtChange(value)
                  }
                />
                <InputDateTime
                  value={disconnectedAt}
                  error={Boolean(disconnectedAtError)}
                  warning={
                    !disconnectedAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["disconnectedAt"]
                    )
                  }
                  helperText={
                    disconnectedAtError ||
                    satelliteMachineUpdateStore.warnings["disconnectedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineDisconnectedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineDisconnectedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onDisconnectedAtChange(value)
                  }
                />
                <InputDateTime
                  value={tunnelConnectedAt}
                  error={Boolean(tunnelConnectedAtError)}
                  warning={
                    !tunnelConnectedAtError &&
                    Boolean(
                      satelliteMachineUpdateStore.warnings["tunnelConnectedAt"]
                    )
                  }
                  helperText={
                    tunnelConnectedAtError ||
                    satelliteMachineUpdateStore.warnings["tunnelConnectedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineTunnelConnectedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineTunnelConnectedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onTunnelConnectedAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="relations"
              errorText={satelliteMachineUpdateStore.getCardErrors("relations")}
              title={langStore.groupSatelliteMachineRelationsLabel}
              collapsible={true}
              expanded={satelliteMachineUpdateStore.getCardState("relations")}
              toggleExpand={() =>
                satelliteMachineUpdateStore.toggleCardState("relations")
              }
            >
              <FormControl fullWidth></FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
